import React, { createContext, useContext, useRef, useCallback, useState } from "react";

const ContainerRefContext = createContext(null);

export const ContainerRefProvider = ({ children ,className }) => {
  const containerRef = useRef(null);

  // This will store external scroll handler provided by pages/components
  const [externalScrollHandler, setExternalScrollHandler] = useState(null);

  // main scroll handler used internally
  const handleScroll = useCallback(
    (e) => {
      // if a page/component has registered a function, call it
      if (typeof externalScrollHandler === "function") {
        externalScrollHandler(e, containerRef.current);
      }
    },
    [externalScrollHandler]
  );

  return (
    <ContainerRefContext.Provider
      value={{
        containerRef,
        setScrollHandler: setExternalScrollHandler, // expose setter
      }}
    >
      <div
        ref={containerRef}
        className={className}
        id="main-container"
        style={{
          maxHeight: "100vh",
          minHeight: "100vh",
          overflowX: "hidden",
          overflowY: "auto",
        }}
        onScroll={handleScroll}
      >
        {children}
      </div>
    </ContainerRefContext.Provider>
  );
};

export const useContainerRef = () => {
  const ctx = useContext(ContainerRefContext);
  if (!ctx) return null;
  return ctx;
};
